import React from 'react';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux'
import styles from './GoalIcon.module.css';

library.add(fas);

class GoalIcon extends React.Component {


    getIcon() {
        return this.props.icon ? <FontAwesomeIcon icon={this.props.icon} /> : <FontAwesomeIcon icon='trophy' />;
    }

    render() {
        return (
            <span className={styles.wrapper}>
                {this.getIcon()}
            </span>
        );
    }
}

function mapStateToProps(state, ownprops) {
    let icon = ownprops.id ? state.entities.masterData.PTMASTERGOALS[ownprops.id].MGICON : undefined;

    return {
        icon
    };
}

const connectedGoalIcon = connect(mapStateToProps)(GoalIcon);
export { connectedGoalIcon as GoalIcon };
